import styled from "styled-components";

import Background from '../../../../assets/images/background/map-1-1.png';
import Background2 from '../../../../assets/images/background/map-1-2.png';

export const BaseComp = styled.div`
    display: flex;
    height: 100%;
    background-color: var(--setra-blue);

`;

export const BaseContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    @media only screen and (max-width: 1000px) {
        flex-direction: column;
    }
`;

export const TextContent = styled.div`
    color: var(--purple-dark);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1%;
    @media only screen and (max-width: 800px) {
        width: 100%;
    }
    .operation {
        text-align: center;
        margin-top: 1%;
    }
`;

export const TextTitle = styled.div`
    text-align: left;
    color: white;


    h1 {
        font-size: 39px;
        text-align: left;
        color: white;
        font-family: "Rubik", Sans-serif;
    }
    @media only screen and (max-width: 800px) {
        margin-bottom: 2%;
        h1 {
            margin-bottom: 10px;
        }
        
    }
`;

export const TextBody = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 24px;
    text-align: left;
    padding: 10px;
    p {
        color: var(--aside-background);
        font-family: "Montserrat", Sans-serif;
    }
    @media only screen and (max-width: 800px) {
        justify-content: left;
        display: flex;
        flex-direction: column;
        align-items: left;
        margin-bottom: 2%;
        p {
            font-size: 20px;
        }
    }
`;


export const Img = styled.img`
    width: 60%;
    height: auto;
    @media only screen and (max-width: 800px) {
        width: 90%;
        height: auto;
    }
    margin: 1%;
`;

export const IconsDiv = styled.div`
    @media only screen and (max-width: 800px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const IconBox = styled.div`
    display: flex;
    flex-direction: row;
    margin: 1%;
    align-items: center;
    text-align: center;
    p {
        margin-left: 10px;
    }
`;

export const OurMission = styled.div`
`;